"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _TextWrapper = _interopRequireDefault(require("../TextWrapper"));
var _excluded = ["actionButtonText", "actionCloseButton", "autoHideDuration", "alignment", "classes", "ContentProps", "dataMetrics", "icon", "linesOfText", "message", "onClose", "onActionButtonClick", "variant", "truncateText"],
  _excluded2 = ["contentPropsRoot", "errorButton", "error", "iconContainer", "info", "removeMaxHeight"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    contentPropsRoot: {
      background: function background(_ref) {
        var variant = _ref.variant;
        return variant === 'error' ? theme.palette.error.dark : null;
      },
      marginTop: function marginTop(_ref2) {
        var variant = _ref2.variant;
        return variant === 'error' ? 64 : null;
      },
      maxWidth: function maxWidth(_ref3) {
        var variant = _ref3.variant;
        return variant === 'error' ? 624 : null;
      }
    },
    errorButton: {
      color: 'inherit'
    },
    iconContainer: {
      '& > *': {
        height: 24,
        width: 24
      },
      color: theme.palette.background.paper,
      height: 24,
      marginRight: 16,
      width: 24
    },
    removeMaxHeight: {
      maxHeight: 'inherit'
    }
  };
});
var ALIGNMENT_MAP = {
  error: {
    top: {
      horizontal: 'center',
      vertical: 'top'
    }
  },
  info: {
    center: {
      horizontal: 'center',
      vertical: 'bottom'
    },
    left: {
      horizontal: 'left',
      vertical: 'bottom'
    },
    right: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  }
};
var AUTO_HIDE_DURATION_IN_MS_MAP = {
  error: 5000,
  info: 3000
};
var defaultProps = {
  alignment: 'left',
  dataMetrics: {
    root: 'fuse_snackbar'
  },
  truncateText: true,
  variant: 'info'
};

/**
 * Snackbars inform users of a process that an app has performed or will perform.
 * They appear temporarily, towards the bottom of the screen.
 * They shouldn’t interrupt the user experience, and they don’t require user input to disappear.
 */
var _ref4 = /*#__PURE__*/_react["default"].createElement(_Close["default"], null);
var Snackbar = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var actionButtonText = props.actionButtonText,
    actionCloseButton = props.actionCloseButton,
    autoHideDuration = props.autoHideDuration,
    alignment = props.alignment,
    classes = props.classes,
    ContentProps = props.ContentProps,
    dataMetrics = props.dataMetrics,
    icon = props.icon,
    linesOfText = props.linesOfText,
    message = props.message,
    onClose = props.onClose,
    onActionButtonClick = props.onActionButtonClick,
    variant = props.variant,
    truncateText = props.truncateText,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useStyles = useStyles({
      variant: variant
    }),
    contentPropsRoot = _useStyles.contentPropsRoot,
    errorButton = _useStyles.errorButton,
    error = _useStyles.error,
    iconContainer = _useStyles.iconContainer,
    info = _useStyles.info,
    removeMaxHeight = _useStyles.removeMaxHeight,
    useClasses = (0, _objectWithoutProperties2["default"])(_useStyles, _excluded2);
  var actionButton = null;
  var contentPropsClassName = ContentProps && ContentProps.className;
  var snackbarAlignment = 'error'.match(new RegExp(variant, 'i')) ? 'top' : alignment;
  var actionClose = actionCloseButton ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    style: {
      padding: 0
    },
    key: "close",
    "aria-label": "Close",
    color: "inherit",
    onClick: onClose
  }, _ref4) : null;
  if (actionButtonText) {
    actionButton = /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, errorButton, variant === 'error')),
      key: "snackbarActionButton",
      darkBackgroundTheme: "primary",
      color: "primary",
      variant: "text",
      onClick: onActionButtonClick
    }, actionButtonText);
  }
  var autoHideDurationMs = autoHideDuration === undefined ? AUTO_HIDE_DURATION_IN_MS_MAP[variant] : autoHideDuration;
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], (0, _extends2["default"])({
    ContentProps: _objectSpread({}, ContentProps, {
      classes: {
        root: removeMaxHeight
      },
      className: (0, _classnames["default"])(contentPropsRoot, contentPropsClassName)
    }),
    action: [actionButton, actionClose],
    anchorOrigin: ALIGNMENT_MAP[variant][snackbarAlignment],
    autoHideDuration: autoHideDurationMs,
    classes: _objectSpread({}, useClasses, {}, classes),
    "data-metrics": mergedDataMetrics.root,
    message: icon ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: iconContainer
    }, icon), /*#__PURE__*/_react["default"].createElement(_TextWrapper["default"], {
      maxRows: linesOfText,
      tooltipText: message,
      autoTooltip: true
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      style: {
        color: 'inherit'
      }
    }, message))) : /*#__PURE__*/_react["default"].createElement(_TextWrapper["default"], {
      maxRows: truncateText ? linesOfText : null,
      tooltipText: message,
      autoTooltip: true
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      style: {
        color: 'inherit'
      }
    }, message)),
    onClose: onClose,
    ref: ref
  }, rest));
});
Snackbar.defaultProps = defaultProps;
Snackbar.displayName = 'Snackbar';
Snackbar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Text to display in the action button.
   */
  actionButtonText: _propTypes["default"].string,
  /**
   * Display the close icon.
   */
  actionCloseButton: _propTypes["default"].bool,
  /**
   * Type of alignment to place Snackbar.
   */
  alignment: _propTypes["default"].oneOf(['left', 'center', 'right']),
  /**
   * The number of milliseconds to wait before automatically calling the onClose function.
   * onClose should then set the state of the open prop to hide the Snackbar.
   * This behavior is disabled by supplying a value of null.
   */
  autoHideDuration: _propTypes["default"].number,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/snackbar/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Properties applied to the SnackbarContent element.
   */
  ContentProps: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The icon to display before the message inside the snackbar.
   */
  icon: _propTypes["default"].node,
  /**
   * Number of Lines of Text before wrapping the text in the message.
   */
  linesOfText: _propTypes["default"].number,
  /**
   * The message to display in the Snackbar.
   */
  message: _propTypes["default"].string.isRequired,
  /**
   * Callback fired when the action button is clicked.
   */
  onActionButtonClick: _propTypes["default"].func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically onClose is used to set state in the parent component, which is used to control the Snackbar open prop.
   * The reason parameter can optionally be used to control the response to onClose, for example ignoring clickaway.
   * Signature:
   * function(event: object, reason: string) => void
   * event: The event source of the callback
   * reason: Can be:"timeout" (autoHideDuration expired) or: "clickaway"
   */
  onClose: _propTypes["default"].func,
  /**
   * If true, Snackbar is open.
   */
  open: _propTypes["default"].bool,
  /**
   * Controls text truncation and max-height of 68px. Defaults to `true`.
   */
  truncateText: _propTypes["default"].bool,
  /**
   * Type of snackbar.
   */
  variant: _propTypes["default"].oneOf(['info', 'error'])
} : {};
var _default = Snackbar;
exports["default"] = _default;